export default __webpack_public_path__ + "static/media/S_CoreDream_3Light.22b7af16.woff";